import { Component, Injector, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { AppComponentBase } from "@shared/app-component-base";
import { ConsultaDto, ConsultaServiceProxy, PacienteGroupDto, PedidoDto, ProfissionalSaudeDto, TipoPedidoEnum, TipoUsuarioEnum } from "@shared/service-proxies/service-proxies";
import * as FileSaver from 'file-saver';
import { AnexarExameDialogComponent } from "../anexar-exame/anexar-exame-dialog.component";
import { BsModalService } from "ngx-bootstrap/modal";

@Component({
    selector: 'exame-prescricao',
    templateUrl: './exame-prescricao.component.html',
    styleUrls: ['./exame-prescricao.component.scss'],
})
export class ExamePrescricaoComponent extends AppComponentBase implements OnDestroy {
    @Input() consulta: ConsultaDto;
    @Input() profissional: ProfissionalSaudeDto;
    @Input() paciente: PacienteGroupDto;
    @Input() pedido: PedidoDto;

    private subscriptions: Subscription[] = [];

    constructor(
        injector: Injector,
        private readonly _consultaService: ConsultaServiceProxy,
        private readonly _modalService: BsModalService,
    ) { super(injector) }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    get profissionalNome(): string {
        return this.profissional?.nome ?? "";
    }

    get pacienteNome(): string {
        return this.paciente?.nome ?? "";
    }

    get isPrescricao(): boolean {
        return this.pedido.tipo == TipoPedidoEnum._0;
    }

    get isExame(): boolean {
        return this.pedido.tipo == TipoPedidoEnum._1;
    }

    get isPaciente(): boolean {
        return this.appSession.user.tipoUsuarioEnum === TipoUsuarioEnum._0
    }

    anexarExame() {
        this._modalService.show(
            AnexarExameDialogComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
                initialState: {
                    consulta: this.consulta,
                    solicitacaoId: this.pedido.id,
                }
            }
        )

    }

    download() {
        abp.ui.setBusy();
        const sub = this._consultaService.getTemporaryLink(this.pedido.urlArquivo)
            .pipe(
                finalize(() => {
                })
            )
            .subscribe(async x => {
                await fetch(x).then(r => {
                    r.blob().then(aux => {
                        FileSaver.saveAs(aux, `${this.pedido.nome}.${this.pedido.ext}`);
                        abp.ui.clearBusy();
                    })
                });
            });
        this.subscriptions.push(sub);
    }
}
